import {
  isCardsOrVoucher,
  isBoleto,
  isCash,
  isDebitCard,
  isBankTransfer,
  isPix
} from '@/enums/payment-method.enum'

import { hasError } from '@/enums/status-transaction.enum'
import { statusTag } from '@utils/status-tag.utils'

const ENTRY_MODE_ECOMMERCE = 'ecommerce'

class TransactionDetailsManager {
  constructor (data) {
    if (!data) throw new Error('Missing transaction')
    if (!Object.values(data).length > 0)
      throw new Error('Prop transactionList hast values!')

    this.data = data
  }

  getStatus ({ status }) {
    if (!status) throw new Error('Missing status')
    return statusTag(status)
  }

  isPhysical (entryMode) {
    if (!entryMode) return false
    return entryMode !== ENTRY_MODE_ECOMMERCE
  }

  isCardOrVoucher ({ type, status }) {
    return (isDebitCard(type) && !hasError(status)) || isCardsOrVoucher(type)
  }

  adapterData () {
    const { transaction } = this.data

    return {
      id: transaction.id,
      value: transaction.amount ?? '-',
      status: {
        text: transaction.status,
        variant: transaction.color
      }
    }
  }

  adapterDataAntiFraud () {
    const { transaction } = this.data
    if (!transaction?.anti_fraud) return
    if (!Object.values(transaction.anti_fraud).length) return

    return {
      antifraud: transaction.anti_fraud.provider_name ?? '-',
      score: transaction.anti_fraud.score ?? '-',
      status: {
        text: transaction.anti_fraud.status,
        variant: this.getStatus(transaction.anti_fraud)
      },
      returnCode: transaction.anti_fraud.return_code ?? '-',
      message: transaction.anti_fraud.return_message ?? '-'
    }
  }

  adapterDataAcquirer () {
    const { transaction, orderKey } = this.data

    if (!this.isCardOrVoucher(transaction)) return

    if (!transaction?.acquirer) return
    if (!Object.values(transaction.acquirer).length) return

    return {
      acquirer: transaction.acquirer ?? '-',
      message: transaction.acquirer_message ?? '-',
      returnCode: transaction.acquirer_return_code ?? '-',
      tid: transaction?.acquirer_tid,
      nsu: transaction?.acquirer_nsu,
      autorizationCode: transaction?.acquirer_auth_code,
      pgid: transaction?.pgid ?? '-',
      orderKey: orderKey ?? '-',
      operationType: transaction?.operation_type ?? '-'
    }
  }

  #adapterCards (transaction) {
    if (!this.isCardOrVoucher(transaction)) return

    return {
      nextAttempt: transaction?.next_attempt,
      attemptCount: transaction?.attempt_count ?? -1,
      captureMethod: this.isPhysical(transaction.entry_mode)
        ? transaction.entry_mode
        : undefined,
      deviceSerialNumber: this.isPhysical(transaction.entry_mode)
        ? transaction.device_serial_number
        : undefined
    }
  }

  adapterOthers () {
    const { transaction } = this.data

    const struct = {
      endToEndId: transaction?.end_to_end_id,
      pgid: isPix(transaction.type) ? transaction.pgid : undefined,
      description: isCash(transaction.type)
        ? transaction.description
        : undefined,
      paidAtDate: isBoleto(transaction.type) ? transaction.paid_at : undefined,
      paidAtDateHour: isBankTransfer(transaction.type)
        ? transaction.paid_at
        : undefined,
      ...this.#adapterCards(transaction)
    }

    return {
      ...struct,
      hasOthers: Object.values(struct).some(
        el => el !== undefined && el !== '' && el >= 0
      )
    }
  }
}

export default TransactionDetailsManager
